import React, { useEffect, useState ,useRef } from 'react';
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom';
import './StudentDashboard.css';
import CapstoneOverview from './CapstoneOverview';
import Submission from './Submission';
import Feedback from './Feedback';
import TeamFormation from './TeamFormation';
import DisplayBoard from './DisplayBoard2';
import './Dashboard.css';
import Prototype from './Prototype';
import BMC from './DisplayBoard/bmc2';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from 'utils/constants';
import PublishedCapstoneTheme from './PublishedCapstoneTheme';
import PortfolioSection4 from './portfolio/PortfolioSection4';
import PortfolioSection1 from './portfolio/PortfolioSection1';
import PortfolioSection3 from './portfolio/PortfolioSection3';
import PortfolioSection2 from './portfolio/PortfolioSection2';
import PortfolioSearch from './PortfolioSearch';

// Mock data for demo purposes
const mockNotifications = [
  "Feedback received on Journal 1",
  "Panel review scheduled for 15th August",
  "Deadline for Portfolio Section II is approaching"
];

const mockTheme = "Future of Sustainable Technologies";

function StudentDashboard() {
  const [notifications, setNotifications] = useState(mockNotifications);
  const [inGroup, setInGroup] = useState(false)
  const [teamName, setTeamName] = useState("")
  const [teamNumber, setTeamNumber] = useState(null)
  const [facilitatorName, setFacilitatorName] = useState(null)
  const [teamMembers, setTeamMembers] = useState([])
  const [displayBoardStatus, setDisplayBoardStatus] = useState(0);
  const [teamFormationLocked, setTeamFormationLocked] = useState(false);
  const [teamMembershipLocked, setTeamMembershipLocked] = useState(false);
  const assignTeam = (res_data_data) => {
    let all_is_good_flag = false
    let property = "in_group";
    if (res_data_data.hasOwnProperty(property)) {
      if ((res_data_data[property] - 0)) {
        // console.log(property)
        // console.log(res_data_data[property])
        property = "team";
        if (res_data_data.hasOwnProperty(property)) {
          // console.log(property)
          // console.log(res_data_data[property])
          const team = res_data_data[property]
          // console.log(team)
          if ((team.hasOwnProperty("display_board_status") && team.hasOwnProperty("team_name")) && (team.hasOwnProperty("facilitator_name")) && (team.hasOwnProperty("team_members"))) {
            setTeamMembers(team["team_members"])
            setFacilitatorName(team["facilitator_name"])
            setTeamName(team["team_name"])
            setTeamNumber(team["team_number"] ?? null)
            setDisplayBoardStatus(team["display_board_status"] - 0)
            setTeamMembershipLocked(Number(team["membership_locked"]) === 1)
            all_is_good_flag = true;
          }
        }
      }
    }
    setInGroup(all_is_good_flag)
  }

  useEffect(() => {

    Swal.showLoading();
    axios.get(`${BASE_URL}/capstone/teamformation/getteamformation.php`)
      .then(res => {
        if (res?.data?.data) {
          const res_data_data = res?.data?.data;
          setTeamFormationLocked(Number(res_data_data.team_formation_locked) === 1);
          // console.log(res_data_data)
          assignTeam(res_data_data);
        }
        Swal.close();
      }).catch(err => {
        Swal.close();
      })

  }, [])
const dropdownRef = useRef(null);
  // For simplicity, this is a static list. In a real-world application, you might fetch this from a server.
  // const [teamMembers, setTeamMembers] = useState(["John Doe", "Jane Smith", "Robert Brown"]);
  const [dropdownMenuLinkPortfolioShow, setDropdownMenuLinkPortfolioShow] = useState(false)
  useEffect(() => {
  function handleClickOutside(event) {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target)
    ) {
      setDropdownMenuLinkPortfolioShow(false);
    }
  }

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);
  return (
    <Router>
      <div className="dashboard">
        {/* Navigation */}
        <div className='nav'>
          <Link to="/StudentDashboard/overview">Overview</Link>
          <Link to="/StudentDashboard/capstone-theme">Capstone Challenge</Link>
          <Link to="/StudentDashboard/team-formation">Team Formation</Link>
          <Link to="/StudentDashboard/portfolio-search">Search All Portfolios</Link>

          {
            inGroup ? (<>

              <div className={`dropdown ${dropdownMenuLinkPortfolioShow ? "show" : ""}`} onClick={() => { setDropdownMenuLinkPortfolioShow(x => !x) }}
                // href="#"
                style={{
                  cursor: "pointer",
                  // color: "white",
                  // display: "flex",
                  // flexDirection: "column",
                }}
                 ref={dropdownRef}
              >
                Portfolio
                <div className="dropdown-menu" aria-labelledby="dropdownMenuLinkPortfolio"
                  style={{
                    // color: "white",
                    display: "flex",
                    flexDirection: "column",
                    padding: "3px"
                  }}
                >
                  <Link to="/StudentDashboard/portfolio_section_1">Section I: The problem background</Link>
                  <Link to="/StudentDashboard/portfolio_section_2">Section II: Ideas and solutions</Link>
                  <Link to="/StudentDashboard/portfolio_section_3">Section III: Experiment ideas and solutions</Link>
                  <Link to="/StudentDashboard/portfolio_section_4">Section IV: Analyzing and communicating</Link>
                </div>
              </div>

              <Link to="/StudentDashboard/display_board">Display Board</Link>
              {
                ((displayBoardStatus - 0) === 1) ? (
                  <>
                    <Link to="/StudentDashboard/bmc">BMC</Link>
                    <Link to="/StudentDashboard/prototype">Prototype</Link>
                  </>
                ) : null
              }
              <Link to="/StudentDashboard/feedback">Feedback</Link>
            </>

            ) : null
          }
        </div>

        <Switch>

          {/* <Route path="/StudentDashboard/overview">
            <CapstoneOverview />
          </Route> */}

          {/* Team Formation */}
          <Route path="/StudentDashboard/team-formation">
            <TeamFormation
              inGroup={inGroup}
              setInGroup={setInGroup}
              setTeamMembers={setTeamMembers}
              setTeamName={setTeamName}
              teamName={teamName}
              teamNumber={teamNumber}
              facilitatorName={facilitatorName}
              setFacilitatorName={setFacilitatorName}
              teamMembers={teamMembers}
              assignTeam={assignTeam}
              teamFormationLocked={teamFormationLocked}
              teamMembershipLocked={teamMembershipLocked}

            />
          </Route>

          <Route path="/StudentDashboard/portfolio-search">
            <PortfolioSearch />
          </Route>

          {/* Capstone Theme */}
          <Route path="/StudentDashboard/capstone-theme">
            <PublishedCapstoneTheme />
          </Route>

          <Route path="/StudentDashboard/display_board">
            <DisplayBoard displayBoardStatus={displayBoardStatus} />
          </Route>

          <Route path="/StudentDashboard/bmc">
            <BMC />
          </Route>

          <Route path="/StudentDashboard/prototype">
            <Prototype />
          </Route>

          <Route path="/StudentDashboard/portfolio_section_1">
            <PortfolioSection1 />
          </Route>
          <Route path="/StudentDashboard/portfolio_section_2">
            <PortfolioSection2 />
          </Route>
          <Route path="/StudentDashboard/portfolio_section_3">
            <PortfolioSection3 />
          </Route>
          <Route path="/StudentDashboard/portfolio_section_4">
            <PortfolioSection4 />
          </Route>
          {/* Feedback */}
          <Route path="/StudentDashboard/feedback">
            <Feedback />
          </Route>
          {/* Resources */}
          <Route >
            <CapstoneOverview
              inGroup={inGroup}
              displayBoardStatus={displayBoardStatus}
            />
          </Route>


        </Switch>
      </div>
    </Router>
  );
}

export default StudentDashboard;
